//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { EditIcon, LockIcon } from "@chakra-ui/icons";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  createStandaloneToast,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Grid,
  GridItem,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  SlideDirection,
  Spacer,
  Stack,
  Text,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import {
  OverlayWrapper,
  useOverlayDisclosure,
} from "../../components/OverlayRouter";

export const ForceDrawerDisplay: React.FC<{
  isMobile?: boolean;
  isOpen: boolean;
  onClose: any;
  isDesktopDrawer?: boolean;
  closeOnOverlayClick?: boolean;
  closeOnEsc?: boolean;
  placement?: SlideDirection;
  header?: string;
  key?: string;
  size?: string;
  path: string;
  displayCloseButton?: boolean;
  isFullHeight?: boolean;
  children: any;
  exact?: boolean;
  [key: string]: any;
}> = observer(
  ({
    isOpen,
    isMobile,
    onClose,
    isDesktopDrawer = false,
    closeOnOverlayClick = true,
    closeOnEsc = true,
    size = "2xl",
    desktopSize = "xl",
    header,
    displayCloseButton = true,
    placement = "right",
    isFullHeight = true,
    path,
    exact = false,
    key,
    children,
    ...rest
  }) => {
    // if (isMobile || isDesktopDrawer) {
    //   return (
    //     <OverlayWrapper exact={exact} path={path}>
    //       <Drawer
    //         isOpen={isOpen}
    //         placement={placement}
    //         closeOnOverlayClick={closeOnOverlayClick}
    //         closeOnEsc={closeOnEsc}
    //         onClose={onClose}
    //         size={isMobile ? (["full", "lg", "lg", "lg"] as any) : desktopSize}
    //         isFullHeight={isFullHeight}
    //       >
    //         <DrawerOverlay />
    //         <DrawerContent opacity={1} bg="white" overflow="auto" {...rest}>
    //           {displayCloseButton ? <DrawerCloseButton zIndex={1} /> : null}
    //           <DrawerBody py={6}></DrawerBody>
    //         </DrawerContent>
    //       </Drawer>
    //     </OverlayWrapper>
    //   );
    // }

    if (isDesktopDrawer) {
      return (
        <Drawer
          isOpen={isOpen}
          placement={placement}
          onClose={onClose}
          closeOnEsc={closeOnEsc}
          closeOnOverlayClick={closeOnOverlayClick}
          size={desktopSize}
          isFullHeight
        >
          <DrawerOverlay />
          <DrawerContent overflow="auto">
            {displayCloseButton ? (
              <DrawerCloseButton zIndex="modal" bg="white" />
            ) : null}
            <DrawerBody py={6}>{children}</DrawerBody>
          </DrawerContent>
        </Drawer>
      );
    }

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={size}
        closeOnEsc={closeOnEsc}
        closeOnOverlayClick={closeOnOverlayClick}
        key={key}
      >
        <ModalOverlay />
        <ModalContent overflow="auto" rounded="lg">
          {header && <ModalHeader>{header}</ModalHeader>}
          {displayCloseButton ? <ModalCloseButton zIndex="modal" /> : null}
          <ModalBody px={8} py={10}>
            {children}
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  },
);

export const CustomPopupDisplay: React.FC<{
  isMobile?: boolean;
  isOpen: boolean;
  onClose: any;
  isDesktopDrawer?: boolean;
  closeOnOverlayClick?: boolean;
  closeOnEsc?: boolean;
  placement?: SlideDirection;
  header?: string;
  key?: string;
  size?: string;
  path: string;
  displayCloseButton?: boolean;
  isFullHeight?: boolean;
  children: any;
  exact?: boolean;
  [key: string]: any;
}> = observer(
  ({
    isOpen,
    isMobile,
    onClose,
    isDesktopDrawer = false,
    closeOnOverlayClick = true,
    closeOnEsc = true,
    size = "2xl",
    desktopSize = "xl",
    header,
    displayCloseButton = true,
    placement = "right",
    isFullHeight = true,
    path,
    exact = false,
    key,
    children,
    ...rest
  }) => {
    if (isMobile || isDesktopDrawer) {
      return (
        <OverlayWrapper exact={exact} path={path}>
          {/* <Drawer
            isOpen={isOpen}
            placement={placement}
            closeOnOverlayClick={closeOnOverlayClick}
            closeOnEsc={closeOnEsc}
            onClose={onClose}
            size={isMobile ? (["full", "lg", "lg", "lg"] as any) : desktopSize}
            isFullHeight={isFullHeight}
          >
            <DrawerOverlay />
            <DrawerContent opacity={1} bg="white" overflow="auto" {...rest}>
              {displayCloseButton ? <DrawerCloseButton zIndex={1} /> : null}
              <DrawerBody py={6}> */}
          <Stack>{children}</Stack>
          {/* </DrawerBody>
            </DrawerContent>
          </Drawer> */}
        </OverlayWrapper>
      );
    }

    // if (isDesktopDrawer) {
    //   return (
    //     <Drawer
    //       isOpen={isOpen}
    //       placement={placement}
    //       onClose={onClose}
    //       closeOnEsc={closeOnEsc}
    //       closeOnOverlayClick={closeOnOverlayClick}
    //       size={desktopSize}
    //       isFullHeight
    //     >
    //       <DrawerOverlay />
    //       <DrawerContent overflow="auto">
    //         {displayCloseButton ? (
    //           <DrawerCloseButton zIndex="modal" bg="white" />
    //         ) : null}
    //         <DrawerBody py={6}>{children}</DrawerBody>
    //       </DrawerContent>
    //     </Drawer>
    //   );
    // }

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={size}
        closeOnEsc={closeOnEsc}
        closeOnOverlayClick={closeOnOverlayClick}
        key={key}
      >
        <ModalOverlay />
        <ModalContent overflow="auto" rounded="lg">
          {header && <ModalHeader>{header}</ModalHeader>}
          {displayCloseButton ? <ModalCloseButton zIndex="modal" /> : null}
          <ModalBody px={8} py={10}>
            {children}
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  },
);

export const LockedForm: React.FC<{
  hasPassword?: boolean;
  title: string;
  canEdit?: boolean;
  onClick?: () => void;
  completed?: boolean;
  description?: string;
  [key: string]: any;
}> = ({
  hasPassword = false,
  title,
  description,
  canEdit,
  onClick,
  completed,
  ...rest
}) => {
  const [loading, setLoading] = React.useState(false);
  function handleClick() {
    setLoading(true);
    if (onClick) {
      onClick();
    }
  }
  return (
    <HStack borderBottomWidth="1px" {...rest}>
      <Stack>
        <Text fontWeight="medium">{title}</Text>
        <Text>{description}</Text>
      </Stack>
      <Spacer />
      {canEdit ? (
        <Button onClick={handleClick} isLoading={loading} colorScheme="blue">
          {completed ? "Edit" : "Complete"}
        </Button>
      ) : null}
    </HStack>
  );
};

export const CompletedTutorForm: React.FC<{
  onSubmit?: (params?: any) => any;
  formSummary?: Array<any>;
  formHeader?: string;
  gridTemplate?: string;
  onEdit?: () => void;
}> = observer(
  ({ formSummary, gridTemplate, onSubmit, onEdit, formHeader, children }) => {
    const [path, setPath] = React.useState("/tutor-form");
    const { isOpen, onClose, onOpen } = useOverlayDisclosure(path);
    const isMobile = false;
    // const isMobile = useMedia("(max-width: 420px)");
    return (
      <Box
        borderWidth="2xs"
        borderColor="neutral.500"
        px={[5, 8]}
        py={[5, 6]}
        width="100%"
        boxShadow="sm"
        rounded="lg"
      >
        <CustomPopupDisplay
          path={path}
          isMobile={isMobile}
          isOpen={isOpen}
          onClose={onClose}
          closeOnOverlayClick={false}
        >
          {React.cloneElement(children as React.ReactElement<any>, {
            onSubmit: (formData: any) => {
              onSubmit &&
                onSubmit(formData).then((res) => {
                  onClose();
                });
            },
          })}
        </CustomPopupDisplay>
        <Box>
          <HStack mb={3}>
            <Text fontWeight="medium" fontSize={["2xl", "3xl"]}>
              {formHeader}
            </Text>
            <Spacer />
            <Button
              colorScheme="blue"
              variant="link"
              size="sm"
              leftIcon={<EditIcon />}
              onClick={() => {
                setPath("/tutor-form");
                onEdit();
                onOpen();
              }}
            >
              Edit
            </Button>
          </HStack>

          <Grid templateColumns={gridTemplate} gap={2}>
            {formSummary.map((info, index) => {
              return (
                <GridItem fontSize={["sm", "md"]} key={index}>
                  {info}
                </GridItem>
              );
            })}
          </Grid>
        </Box>
      </Box>
    );
  },
);

export const CompletedEducationWorkForm: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <Stack spacing={5} pt={8}>
      {children}
    </Stack>
  );
};

export function displayToast({
  status,
  title,
  description,
  position = "top",
  duration = 7000,
}: {
  status: "info" | "warning" | "success" | "error" | undefined;
  title: string;
  description?: string;
  position?:
    | "top"
    | "top-right"
    | "top-left"
    | "bottom"
    | "bottom-right"
    | "bottom-left";
  duration?: number;
}) {
  const toast = createStandaloneToast();
  toast({
    title,
    description,
    status,
    duration,
    isClosable: true,
    position,
  });
}

export const ConfirmationPrompt: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  canDelete?: boolean;
  loading?: boolean;
}> = ({ isOpen, onClose, canDelete, onDelete, loading, ...rest }) => {
  const cancelRef = React.useRef();
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader fontSize="lg" fontWeight="bold">
          {canDelete ? `Delete Subject` : `Archive Subject`}
        </AlertDialogHeader>

        <AlertDialogBody>
          Are you sure? You can't undo this action afterwards.
        </AlertDialogBody>

        <AlertDialogFooter>
          <Button ref={cancelRef} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="red"
            onClick={onDelete}
            ml={3}
            isLoading={loading}
          >
            {canDelete ? `Delete` : `Archive`}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
